import {
  NotifyConfig,
  NotifyOptions,
  SocketInstance,
  SocketV2MsgDataItem,
  SocketV2Query,
} from "./interface";
import { parseOrderCount } from "./utils";

const HEARTBEAT_INTERVAL = 10000;
const MAX_RECONNECT = 100;
const RECONNECT_INTERVAL = 2000;
let timeConnect = 0;
const NORMAL_CLOSE_SOCKET_CODE = 4001;
let timer = null;
let socket = null;
let queryCache = null;

interface SocketQuery {
  query: SocketV2Query;
}

interface SocketConfig extends NotifyConfig, SocketQuery {}

export function webSocketInit(
  config: SocketConfig,
  opts: NotifyOptions
): SocketInstance {
  const { wss, query } = config;
  if (socket) {
    timeConnect = 0;
    // 先清除前一个的数据
    clearInterval(timer);
    socket.close(NORMAL_CLOSE_SOCKET_CODE);
    socket = null;
    queryCache = null;
  }
  queryCache = query;
  const queryString = JSON.stringify(query);
  socket = new WebSocket(`${wss}?hotelId=${query.hotelId}`);
  socket.onopen = function socketOpen() {
    if (socket) {
      socket.send(queryString);
    }
  };

  socket.onmessage = (ev: any) => {
    timeConnect = 0;
    try {
      const datastring = ev.data;
      if (datastring) {
        const dataObj = JSON.parse(datastring);
        // code 0表示正常数据，222表示是心跳
        if (dataObj.code * 1 === 0) {
          let data: SocketV2MsgDataItem[];
          if (
            // 防止userId的类型不一样及切换酒店后消息就错误接收
            dataObj.data?.userId - query.userId === 0 &&
            dataObj.data?.msgData &&
            dataObj.data?.hotelId - queryCache.hotelId === 0
          ) {
            data = dataObj.data.msgData;
          }
          if (data) {
            const counts = {};
            let hasNewOrder = false;
            data.forEach(function eachFunc(item) {
              if (item.notifyType === "sound") {
                hasNewOrder = true;
              } else {
                counts[item.notifyBusinessType] = item.count;
              }
            });
            const count = parseOrderCount(counts);
            opts.update({
              count,
              hasNewOrder,
            });
          }
        }
      }
    } catch (e) {
      opts.error(e);
    }
  };

  socket.onclose = function socketClose(e) {
    if (e.code === NORMAL_CLOSE_SOCKET_CODE) {
      clearInterval(timer);
      socket = null;
      return;
    }
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    reconnect(config, opts);
  };

  timer = setInterval(() => {
    if (socket) {
      socket.send(queryString);
    }
  }, HEARTBEAT_INTERVAL);

  return {
    socket,
    close(socket1) {
      socket1.close(NORMAL_CLOSE_SOCKET_CODE);
    },
  };
}

function reconnect(config: SocketConfig, opt: NotifyOptions) {
  // lockReconnect加锁，防止onclose、onerror两次重连
  timeConnect += 1;
  if (timeConnect > MAX_RECONNECT) {
    opt.error(new Error("订单通知连接失败，请刷新页面进行重试"));
  }
  // 进行重连
  setTimeout(function () {
    webSocketInit(config, opt);
  }, RECONNECT_INTERVAL);
}
